import { faro } from "@grafana/faro-web-sdk";

// Keys that move focus or dismiss rather than enter a value.
const NAVIGATION_KEYS = new Set([
  "Tab",
  "Shift",
  "Control",
  "Alt",
  "Meta",
  "Escape",
  "ArrowUp",
  "ArrowDown",
  "ArrowLeft",
  "ArrowRight",
  "Home",
  "End",
  "PageUp",
  "PageDown",
]);

// readonly is ignored by HTML on checkbox and radio inputs, so a switch rendered readOnly still
// toggles on space. aria-disabled is advisory only and never blocks input.
const isLockedButReachable = (el) =>
  el instanceof HTMLElement && el.disabled !== true && (el.readOnly === true || el.getAttribute("aria-disabled") === "true");

const describe = (el) => el.getAttribute("name") || el.id || el.getAttribute("aria-label") || el.tagName.toLowerCase();

export function trackLockedFieldInput() {
  let lastReported = null;

  document.addEventListener("focusout", () => {
    lastReported = null;
  });

  document.addEventListener(
    "keydown",
    (event) => {
      const el = event.target;

      if (NAVIGATION_KEYS.has(event.key) || !isLockedButReachable(el) || el === lastReported) {
        return;
      }

      lastReported = el;

      faro?.api?.pushEvent("locked-field-input", {
        field: describe(el),
        element: el.tagName.toLowerCase(),
        inputType: el.type ?? "",
        lock: el.readOnly === true ? "readonly" : "aria-disabled",
        key: event.key,
        path: window.location.pathname,
      });
    },
    true
  );
}
